import {useBooleanAssignment} from '@ezcater/eppo-react';
import EppoFlags from './EppoFlags';

export const useFederationApiEppoFlag = () =>
  useBooleanAssignment(EppoFlags.DriverWebFederation, false);
